function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "color", "variant", "size", "shape", "children", "closeIcon", "arrowIcon", "onClose", "style", "prefix"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useMemo } from 'react';
import { cn, isHexColor, opacityColorByPercent } from "../../../lib/utils";
import { fontGradient, prefixCls } from "../../style/tag";
import { CloseIcon, DirectionrightIcon } from '@bfe/moly-icons';
import { tagVariants } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Tag = /*#__PURE__*/forwardRef(function Tag(props, ref) {
  var className = props.className,
    color = props.color,
    variant = props.variant,
    size = props.size,
    shape = props.shape,
    children = props.children,
    _props$closeIcon = props.closeIcon,
    closeIcon = _props$closeIcon === void 0 ? false : _props$closeIcon,
    _props$arrowIcon = props.arrowIcon,
    arrowIcon = _props$arrowIcon === void 0 ? false : _props$arrowIcon,
    onClose = props.onClose,
    style = props.style,
    prefix = props.prefix,
    others = _objectWithoutProperties(props, _excluded);
  var _style = useMemo(function () {
    if (!color) return {};
    if (!isHexColor(color)) return {};
    if (variant === 'primary') {
      return {
        backgroundColor: color
      };
    }
    return {
      color: color,
      backgroundColor: opacityColorByPercent(color, 0.2)
    };
  }, []);
  var handleClose = function handleClose(e) {
    if (props.disabled) return;
    onClose === null || onClose === void 0 || onClose(e);
  };
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: cn(className, tagVariants({
      color: color,
      variant: variant,
      size: size,
      shape: shape
    })),
    ref: ref,
    "data-disabled": props.disabled ? '' : undefined,
    style: _objectSpread(_objectSpread({}, style), _style)
  }, others), {}, {
    children: [prefix ? /*#__PURE__*/_jsx("div", {
      className: cn(prefixCls),
      children: /*#__PURE__*/_jsx("span", {
        className: fontGradient,
        children: prefix
      })
    }) : null, variant === 'vip-only' ? /*#__PURE__*/_jsx("span", {
      children: children
    }) : children, closeIcon && /*#__PURE__*/_jsx(CloseIcon, {
      className: "cursor-pointer data-[disabled]:cursor-not-allowed",
      "data-disabled": props.disabled ? '' : undefined,
      onClick: handleClose
    }), arrowIcon && /*#__PURE__*/_jsx(DirectionrightIcon, {
      className: size === 'xlarge' ? 'w-[14px] h-[14px]' : 'w-3 h-3'
    })]
  }));
});